<form #editPacienteAlergiaForm="ngForm">
    <app-custom-modal #modal [title]="'Editar alergia'" [subtitle]="''" (onCloseClick)="modal.close()"
        (onSaveClick)="save()" [saveLabel]="'Salvar  →'" [saveDisabled]="editPacienteAlergiaForm.invalid || saving">
        <div class="container">
            <div class="mb-4">
                <label for="alergia" class="form-label required">Alergia</label>
                <input type="text" class="form-control" name="substancia" [(ngModel)]="pacienteAlergia.substancia"
                    placeholder="Digite aqui" #substanciaModel="ngModel" #substanciaEl id="substancia"
                    (input)="getAlergias()" maxlength="150" />

                <div *ngIf="alergias.length > 0 && showList" class="card mt-4 scroll-container">
                    <div *ngFor="let alergia of alergias">
                        <div class="mt-2" (click)="selectAlergia(alergia)"
                            class="row d-flex align-items-center alergia-container">
                            <div class="col-auto d-flex flex-column justify-content-start p-0">
                                <p class="nome-alergia">{{alergia.substancia}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-4">
                <label for="tipoAlergia" class="form-label required">Tipo de alergia</label>
                <select name="tipoAlergia" id="tipoAlergia" class="form-control" required
                    [(ngModel)]="pacienteAlergia.tipoAlergia">
                    <option *ngFor="let tipo of tiposAlergias.TiposAlergia" [value]="tipo.type">{{tipo.name}}</option>
                </select>
            </div>
            <div class="mb-4">
                <label for="observacao" class="form-label">Observação</label>
                <input type="text" class="form-control" name="observacao" [(ngModel)]="pacienteAlergia.observacao"
                    placeholder="Digite aqui" #observacaoModel="ngModel" #observacaoEl id="observacao"
                    maxlength="150" />

                <abp-validation-summary [control]="observacaoModel" [controlEl]="observacaoEl"></abp-validation-summary>
            </div>
        </div>
    </app-custom-modal>
</form>